export default {"src":"/_next/static/media/password-eye-closed.85cec6c5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};